export enum ForgotPasswordFlows {
  SIGN_UP = 'SIGN_UP',
  USER_RESET = 'USER_RESET',
  CHECKOUT = 'CHECKOUT',
  OTA_SIGN_UP = 'OTA_SIGN_UP',
  CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP',
}
